import {
    FETCH_AUTHENTICATED_USER,
    USER_REGISTRATION_SUCCESS,
    USER_UPDATE_SUCCESS,
    AUTHENTICATING_USER,
    AUTHENTICATION_FAILED,
    SAVE_ONBOARDING_STEP,
    SAVE_ONBOARDING_SUCCESS,
    SAVE_ONBOARDING_FAILED,
    GET_RATED_SUCCESS,
    CONFIRM_GET_RATED,
    MYUTR_SELECT_SUCCESS,
    VALIDATE_INVITE_SUCCESS,
    CONFIRM_EMAIL_ACCEPTED,
    FETCH_PAID_HIT_CLUB_SUCCESS,
    FETCH_PAID_HIT_CLUB_PAYMENT_ACCOUNTS_SUCCESS,
    AUTHENTICATION_FAILED_SILENT,
} from '../actions';
import { VALIDATE_RESET_PASSWORD_SUCCESS, CONFIRM_EMAIL_CHANGE } from '../actions/settings-actions';
import {
    ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS,
    ONBOARDING_POST_AUSTRALIA_ONBOARDING_STATUS_SUCCESS,
    ONBOARDING_POST_AUSTRALIA_TENNIS_ID_SUCCESS,
    ONBOARDING_SKIP_UTR_RANGE_SURVEY_SUCCESS,
} from '../actions/onboarding-actions';
import { userIsPaidHitter } from '../utils/user';
import {
    SETTINGS_FETCH_REQUEST,
    SETTINGS_FETCH_SUCCESS,
    SETTINGS_FETCH_FAILURE,
    PREFERENCES_FEED_FETCH_REQUEST,
    PREFERENCES_FEED_FETCH_SUCCESS,
    PREFERENCES_FEED_FETCH_FAILURE,
    SETTINGS_AUSTRALIA_FETCH_REQUEST,
    SETTINGS_AUSTRALIA_FETCH_SUCCESS,
    SETTINGS_AUSTRALIA_FETCH_FAILURE,
} from '../actions/actionTypes/setting-action-types';
import { SUBSCRIBE_UPDATE_PAYMENT_SUCCESS } from '../actions/subscribe-action-types';
import { AUTH_CLEAR_ERROR, AUTH_MAGIC_LINK_SET_CALLBACK_URL } from '../actions/actionTypes/auth-action-types';

const initialState = {
    loading: false,
    saving: false,
    user: null,
    mfaToken: null,
    email: '',
    settings: null,
    paidHitClub: null,
    paidHitClubLoaded: false,
    paidHitClubPaymentAccounts: [],
    paidHitClubPaymentAccountsLoaded: false,
    isFeedPreferencesLoading: false,
    feedPreferences: null,
    feedPreferencesLoadedAtLeastOnce: false,
    australiaSettings: null,
    magicLinkCallbackUrl: null,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATING_USER:
            return {
                ...state,
                loading: true,
                error: null,
                magicLinkCallbackUrl: null,
            };
        case AUTH_MAGIC_LINK_SET_CALLBACK_URL:
            return {
                ...state,
                magicLinkCallbackUrl: action.payload,
            };
        case AUTH_CLEAR_ERROR:
            return {
                ...state,
                error: null,
            };
        case 'SET_MFA_TOKEN':
            return {
                ...state,
                mfaToken: action.payload,
            };
        case FETCH_AUTHENTICATED_USER:
            return {
                ...state,
                loading: false,
                paidHitClubPaymentAccounts: [],
                paidHitClubPaymentAccountsLoaded: false,
                user: {
                    ...action.payload.data,
                    isPaidHitter: !!userIsPaidHitter(action.payload.data),
                },
            };

        case AUTHENTICATION_FAILED:
            return {
                ...state,
                loading: false,
                mfaToken: null,
                error: action.message,
                user: null,
            };
        case AUTHENTICATION_FAILED_SILENT:
            return {
                ...state,
                loading: false,
                mfaToken: null,
                error: null,
                user: null,
            };
        case CONFIRM_EMAIL_ACCEPTED:
        case CONFIRM_EMAIL_CHANGE:
            return {
                ...state,
                user: action.payload,
            };
        case USER_REGISTRATION_SUCCESS:
        case USER_UPDATE_SUCCESS:
        case GET_RATED_SUCCESS:
        case MYUTR_SELECT_SUCCESS:
            return {
                ...state,
                user: action.user,
            };
        case SUBSCRIBE_UPDATE_PAYMENT_SUCCESS:
            // Optimistically set hasPastDueSubscription to false when payment is updated
            return {
                ...state,
                user: state.user ? { ...state.user, hasPastDueSubscription: false } : null,
            };
        case SAVE_ONBOARDING_STEP:
            return {
                ...state,
                saving: true,
            };
        case SAVE_ONBOARDING_SUCCESS:
            return {
                ...state,
                saving: false,
                user: action.payload.data,
            };
        case SAVE_ONBOARDING_FAILED:
            return {
                ...state,
                saving: false,
                error: action.message,
            };
        case CONFIRM_GET_RATED:
            return {
                ...state,
                user: action.payload.data,
            };
        case VALIDATE_INVITE_SUCCESS:
        case 'INVITE:DECLINE_SUCCESS':
            return {
                ...state,
                invite: action.payload.data,
            };
        case VALIDATE_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                resetPassword: action.payload.data,
            };
        case 'CLUBS:CREATE_PERSONAL_SUCCESS':
            return {
                ...state,
                user: {
                    ...state.user,
                    isPersonalClubHeadOrganizer: true,
                },
            };
        case 'CLUBS:CREATE_PRO_SUCCESS':
            return {
                ...state,
                user: {
                    ...state.user,
                    isProClubHeadOrganizer: true,
                },
            };
        case SETTINGS_FETCH_REQUEST:
        case SETTINGS_FETCH_FAILURE:
            return {
                ...state,
                settings: null,
            };
        case SETTINGS_FETCH_SUCCESS:
            return {
                ...state,
                settings: action.data,
            };
        case FETCH_PAID_HIT_CLUB_SUCCESS:
            return {
                ...state,
                paidHitClub: action.payload,
                paidHitClubLoaded: true,
            };
        case FETCH_PAID_HIT_CLUB_PAYMENT_ACCOUNTS_SUCCESS: {
            const { clubPaymentAccounts } = action.payload;
            return {
                ...state,
                paidHitClubPaymentAccounts: clubPaymentAccounts || [],
                paidHitClubPaymentAccountsLoaded: true,
            };
        }
        case ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS: {
            return {
                ...state,
                user: {
                    ...state.user,
                    utrRange: action.payload,
                    utrRangeRequired: false,
                    utrRangeSkipped: false,
                },
            };
        }
        case ONBOARDING_SKIP_UTR_RANGE_SURVEY_SUCCESS: {
            return {
                ...state,
                user: {
                    ...state.user,
                    utrRangeSkipped: true,
                },
            };
        }
        case ONBOARDING_POST_AUSTRALIA_ONBOARDING_STATUS_SUCCESS:
        case ONBOARDING_POST_AUSTRALIA_TENNIS_ID_SUCCESS: {
            return {
                ...state,
                user: {
                    ...state.user,
                    australiaTennisConnectId: action.payload.tennisConnectId,
                },
            };
        }
        case PREFERENCES_FEED_FETCH_REQUEST:
            return {
                ...state,
                isFeedPreferencesLoading: true,
                feedPreferences: null,
            };
        case PREFERENCES_FEED_FETCH_FAILURE:
            return {
                ...state,
                feedPreferences: null,
                isFeedPreferencesLoading: false,
                feedPreferencesLoadedAtLeastOnce: true,
            };
        case PREFERENCES_FEED_FETCH_SUCCESS:
            return {
                ...state,
                feedPreferences: action.data,
                isFeedPreferencesLoading: false,
                feedPreferencesLoadedAtLeastOnce: true,
            };
        case SETTINGS_AUSTRALIA_FETCH_REQUEST:
        case SETTINGS_AUSTRALIA_FETCH_FAILURE:
            return {
                ...state,
                australiaSettings: null,
            };
        case SETTINGS_AUSTRALIA_FETCH_SUCCESS:
            return {
                ...state,
                australiaSettings: action.data,
            };
        default:
            return state;
    }
};
